import { convertQuerySelectorAll } from '../../../../src/js/components/helpers';

type SwiperElement = HTMLElement & {
	swiper?: InstanceType<typeof window.Swiper>;
	swiperResizeHandler?: () => void;
};

convertQuerySelectorAll('.post-slider', (elements) => {
	elements.forEach((element) => {
		const swiperElement = element as SwiperElement;

		// Clean up existing instance and resize handler.
		if (swiperElement.swiperResizeHandler) {
			window.removeEventListener('resize', swiperElement.swiperResizeHandler);
		}
		if (swiperElement.swiper) {
			swiperElement.swiper.destroy(true, true);
			swiperElement.swiper = undefined;
		}

		const initializeSwiper = () => {
			const options = {};

			if (swiperElement.dataset.swiper) {
				Object.assign(options, JSON.parse(swiperElement.dataset.swiper));
			}

			swiperElement.swiper = new window.Swiper(swiperElement, options);
		};

		const destroySwiper = () => {
			if (swiperElement.swiper) {
				swiperElement.swiper.destroy(true, true);
				swiperElement.swiper = undefined;
			}
		};

		const checkViewportAndInitialize = () => {
			if (
				window.innerWidth <= 991 ||
				!swiperElement.classList.contains('post-slider--doctor')
			) {
				if (!swiperElement.swiper) {
					initializeSwiper();
				}
			} else {
				destroySwiper();
			}
		};

		// Store resize handler for cleanup.
		swiperElement.swiperResizeHandler = checkViewportAndInitialize;

		// Initial check.
		checkViewportAndInitialize();

		// Recheck on window resize.
		window.addEventListener('resize', checkViewportAndInitialize);
	});
});
